import RandingStyle1 from "../../randing/RandingStyle1";
// import { Helmet } from "react-helmet";

function Randing039({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle1
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/039/24122701.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/039/24122702.jpg`}
      changedIMG={`${process.env.REACT_APP_CDN_BASE}/images/039/24122703.jpg`} // 스텝 변경되는 이미지
      numberColor="#201c54"
      qOptionColor="lightBlue"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/teal/nextStepButton.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/teal/applyButton.png`}
      companyName="본원"
      apiUrl={apiUrl}
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing039;
